import { useState } from "react";
import { useLocation } from 'react-router-dom';
import { Tab, Row, Card, Tabs, Col } from "react-bootstrap";
import CDATestDataSubmission from "./Component/Test/CDATestDataSubmission";
import CDAProdDataSubmission from "./Component/Prod/CDAProdDataSubmission";
/**
 * Container of the CDA Batch page
 */
const CDADataSubmission = () => {

  const location = useLocation();
  const passedData = location.state;
  // Tab switch: Test & Prod
  const [tab, setTab] = useState(passedData?.envKey ? passedData.envKey : "cdaTest");

  return (
    <>
      <Row >
        <Col xl={11} lg={11} md={11} sm={12}>
          <Card className="p-4">
            <Card.Body className="text-start">
              <h1 id="mainContent" className="header1 text-start mb-3 blue bold">CDA Data Submission</h1>
              <Tabs
                id="controlled-tab"
                activeKey={tab}
                onSelect={(k) => setTab(k)}
              >
                <Tab eventKey="cdaTest" title={"Test Data"}>
                  {tab === "cdaTest"
                    ? <CDATestDataSubmission />
                    : ""
                  }
                </Tab>
                <Tab eventKey="cdaProd" title={"Production Data"}>
                  {tab === "cdaProd"
                    ? <CDAProdDataSubmission />
                    : ""
                  }
                </Tab>
              </Tabs>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default CDADataSubmission;